<div class="tw-p-5">
    <div class="tw-flex tw-justify-end">
        <div (click)="closeDialog()">
            <mat-icon
                aria-hidden="false"
                aria-label="Example close icon"
                fontIcon="close"
            ></mat-icon>
        </div>
    </div>
    <div class="tw-px-3 tw-py-6 tw-text-base tw-font-medium">
        <div class="tw-pb-7">
            {{ "NEW_APPLICATION.SUBMISSION_SELECTION_1" | translate }}
        </div>
        <div class="tw-pb-7">
            {{ "NEW_APPLICATION.SUBMISSION_SELECTION_2" | translate }}
            {{ "NEW_APPLICATION.CGC_EMAIL" | translate }}:
            <span class="tw-text-sky-500">
                {{"imsme@cgc.com.my"}}
            </span>.
        </div>
        <div class="tw-pb-7">
            {{ "NEW_APPLICATION.SUBMISSION_THANKS" | translate }}
        </div>
    </div>
</div>
